import { Box, Dialog, DialogTitle, makeStyles, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AlertDialog from 'src/components/AlertDialog';
import useAddCommentDemand from 'src/hooks/demands/useAddCommentDemand';

import {
  isAssistant as isAssistantSelector,
  isRepresentive as isRepresentiveSelector,
} from 'src/store/selectors/user';
import { isDoctorSelected } from 'src/store/selectors/entity';
import AddCommentForm from './components/AddCommentForm';
import { useSelector } from 'react-redux';
import { ROLES } from 'src/constants/roles';
import { Refresh } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  dialog: {
    margin: '1.5rem',
  },
}));

const initialValues = {
    toRoleId: null,
    action: '',
    comment: '',
    privateComment: '',
    attachments: [],
  };

const AddCommentFormModal = ({ demand, closeDialog, refetchDemands }) => {
  const classes = useStyles();
  const isAssistant = useSelector(isAssistantSelector);
  const isRepresentive = useSelector(isRepresentiveSelector);
  const doctor = useSelector(isDoctorSelected);
  const { t } = useTranslation(['demands', 'common']);
  const { enqueueSnackbar } = useSnackbar();
  const [ addCommentDemand, addCommentDemandQuery] = useAddCommentDemand();


  const handleAddCommentDemand = async (values) => {
    console.log("ENTRA A ENVIAR COMENTARIO", values);
    const data = { ...values };

    const payload = {
      demand: demand.id,
      params: data,
    };
    let res;

    console.log("PETICION:",payload);
    try {
      const res = await addCommentDemand(payload);
      console.log("RESPUESTA:", res);
      closeDialog();
      refetchDemands();
    } catch (err) {
      console.error("Error:", err);
    }
    
    
  };
  const Refresh = () => {
    window.location.reload();
  };
  useEffect(() => {
    if (
      (!addCommentDemandQuery.isLoading && !addCommentDemandQuery.isError && addCommentDemandQuery.data)
    ) {
      enqueueSnackbar(t('modals.success.text_add_coment'), { variant: 'success' });
    }
  }, [
    enqueueSnackbar,
    addCommentDemandQuery.data,
    addCommentDemandQuery.isError,
    addCommentDemandQuery.isLoading,
    t
  ]);

  return (
    <Dialog open={true}>
      <Box className={classes.dialog} display="flex" flexDirection="column">
        <DialogTitle disableTypography={true}>
          <Typography variant="h4" align="center">
            {t('labels.add_comment_modal_title')}
          </Typography>
        </DialogTitle>

        <AddCommentForm
          demand={demand}
          initialValues={initialValues}
          handleAddCommentDemand={handleAddCommentDemand}
          closeDialog={closeDialog}
        />

        {( addCommentDemandQuery.isError) && (
          <AlertDialog
            title={t('modals.error.title_edit_demand')}
            text={
              addCommentDemandQuery.error?.message
              ||
              t('modals.error.text_edit_demand')
            }
            type="error"
          />
        )}
      </Box>
    </Dialog>
  );
};

AddCommentFormModal.propTypes = {
  demand: PropTypes.object,
  closeDialog: PropTypes.func,  
};

export default AddCommentFormModal;
